export * from './reviewSelectors';
export * from './reviewHelpers';

export const LOAD_CONTENT = 'hg/review/LOAD_CONTENT';
export const CONFIRM = 'hg/review/CONFIRM';
export const SET_CONTENT = 'hg/review/SET_CONTENT';
export const SELECT_OPTION = 'hg/review/SELECT_OPTION';
export const SET_REF_NUM = 'hg/review/SET_REF_NUM';
export const DL_PAGE_LOADED = 'hg/review/DL_PAGE_LOADED';
export const DL_PAGE_FAILED = 'hg/review/DL_PAGE_FAILED';
export const SET_DATA = 'mp/review/SET_DATA';
export const SUBMIT_ORDER = 'hg/review/SUBMIT_ORDER';

export const CHECKOUT_TYPE_PPV = 'QuickCheckoutPPV';
export const CHECKOUT_TYPE_DEFAULT = 'QuickCheckout';

// TODO: when the endpoint is ready, replace this dummy content with an empty object
export const initialState = {
  loaded: false,
  content: {
    "review":{
      "flowEntryLink":{
        "entryPointUrl":"/buy/plan",
        "entryPointName":"Back to My Plan"
      },
      currentMonthlyTotalCharges:{},
      reviewChargesSection:{
        "monthlyChargesSection":{
          "allPrices":{},
          "reviewItems":{},
          "reviewSubItems":{
            "premiumChannels":[],
            "equipment":[]
          }
        },
        "oneTimeChargesSection":{
          "allPrices":{
            "prices":[
              {
                "amount":{
                  "dollars":"25",
                  "cents":"00"
                },
                "isOneTime":false,
                "isIncluded":false,
                "priceType":"OneTime"
              }
            ],
            "isIncluded":false
          },
          "reviewItems":{}
        }
      },
      reviewSummary:{
        "newMonthlyTotalCharges":{
          "allPrices":{
            "prices":[],
            "isIncluded":false
          }
        },
        "oneTimeTotalCharges":{}
      },
      "contracts":[],
      "verifications":[]
    }
  }
};

export const review = (state = initialState, action = {}) => {
  switch (action.type) {

    case SET_CONTENT:
      return {
        ...state,
        content: action.payload.content.review
      };

    case SET_REF_NUM:
      return {
        ...state,
        refNum: action.refNum
      };

    case SELECT_OPTION:
      return {
        ...state,
        selectedOption: action.option
      };

    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

// Action Creators
export const setRefNum = refNum => {
  return {
    type: SET_REF_NUM,
    refNum
  };
};

export const selectOption = (paymentOption) => {
  return {
    type: SELECT_OPTION,
    option: paymentOption
  };
};

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};

export const confirm = () => {
  return {
    type: CONFIRM
  };
};

export const submitOrder = (salesSessionId) => {
  return {
    type: SUBMIT_ORDER,
    salesSessionId: salesSessionId
  };
};

export default review;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/review/review.js
 **/